module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAARBAMAAADalBo9AAAALVBMVEUAAAD///////////////////////////////////////////////////////+hSKubAAAADnRSTlMAESIzVWZ3iJmqu8zd7srP4mIAAACQSURBVAjXY2CcvRsGJjIwSL+G814LMOQ5MMCAXwJDXQKcl1fAUNchAOVI9AF5ooshHOalckCegBZEbZYCmMcAVivRwADhRQHVMq8KgPA4GoFqsxQ7wDyhZQwMnZ4NDGyLQLwoAwYGlhKgTqs4IK8RZjkjyD4DuFvsChh0j5fDwFkFBpZz72DgCEi5IAwwMAAAX2o9F8lEyPcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/send-hover.png
// module id = 685
// module chunks = 0